document.addEventListener("DOMContentLoaded", function () {
    const burger = document.querySelector('.burger');
    const menuMobile = document.querySelector('#menuMobile');
    const menubars = document.querySelector('.menubars');
    const cross = document.querySelector('.cross');

    burger.addEventListener("click", () => {
        if(menuMobile.classList.contains("closedBurger")){
            menuMobile.classList.remove("closedBurger");
            menuMobile.classList.add("openBurger");
            menubars.classList.add("hidden");
            cross.classList.remove("hidden");

        }else{
            menuMobile.classList.remove("openBurger");
            menuMobile.classList.add("closedBurger");
            menubars.classList.remove("hidden");
            cross.classList.add("hidden");
        }
    });

});